module.exports = __webpack_public_path__ + "img/reuters.7120b6c4.png";